<template>
  <div class="comment">
    <font-awesome-icon
      class="comment__delete-button"
      icon="times"
      @click="handleDestroyComment(comment.id)"
    />
    <header class="comment__header">
      <div class="comment__author-avatar">
        <avatar
          :name="commentUserName(comment)"
          :img="commentUserAvatarUrl(comment)"
        />
      </div>
      <div class="comment__comment-info">
        <div class="comment__author-name">
          {{ comment.user | fullName }}
        </div>
        <div class="comment__created-at">
          {{ comment.createdAt }}
        </div>
      </div>
    </header>
    <div
      class="comment__body"
      v-html="commentHtml(comment)"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import fullDate from '@/filters/fullDate'
import fullName from '@/filters/fullName'
import textToWeb from '@/filters/textToWeb'

import Avatar from '@/components/ui/Avatar'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  filters: {
    fullDate,
    fullName
  },
  components: {
    Avatar,
    FontAwesomeIcon
  },
  props: {
    comment: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState ({
      content: state => state.content.content
    }),
    commentHtml () {
      return comment => textToWeb(comment.body)
    },
    commentUserName () {
      return comment => fullName(comment.user)
    },
    commentUserAvatarUrl () {
      return comment => comment.user.avatarUrls.thumb
    }
  },
  methods: {
    ...mapActions([
      'fetchContentComments',
      'destroyComment'
    ]),
    handleDestroyComment (commentId) {
      this.destroyComment(commentId)
        .then(() => {
          return this.fetchContentComments(this.content.id)
        })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/comments/Comment.vue